import { MSALAuthWebClient } from '../msal-auth-web-client';
import { StorageItem } from '../enums';
import jwt_decode from 'jwt-decode';
export class MSALAuthService {
    constructor() {
        this.getClaims = function () {
            const token = localStorage.getItem(StorageItem.ACCESS_TOKEN);
            const decodedToken = token && jwt_decode(token);
            return decodedToken;
        };
        let instance = window['ES_PATIENT_HUB']
            ?.azureAuthWebClient;
        if (!instance) {
            const azure = window['ES_PATIENT_HUB']?.config?.authentication?.azure;
            instance = new MSALAuthWebClient({
                clientId: azure?.clientId,
                authority: azure?.authority,
                redirectUri: `${window.location.origin}${azure?.redirectUri}`,
                postLogoutRedirectUri: `${window.location.origin}/login`,
                knownAuthorities: azure?.knownAuthorities,
            });
        }
        Object.setPrototypeOf(this, Object.getPrototypeOf(instance));
        Object.assign(this, instance);
    }
}
//# sourceMappingURL=msal-auth.service.js.map